// Centralized configuration for API endpoints
// This file provides a single source of truth for all API URLs

const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api',
  fastApiUrl: process.env.REACT_APP_FASTAPI_URL || 'http://127.0.0.1:8000/chat',
  streamEndpoint: process.env.REACT_APP_STREAM_ENDPOINT || '/stream',
  
  // Environment info
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
  
  // Helper to log current configuration (useful for debugging)
  logConfig: () => {
    console.log('🔧 Application Configuration:');
    console.log('  Environment:', process.env.NODE_ENV);
    console.log('  API Base URL:', config.apiBaseUrl);
    console.log('  FastAPI URL:', config.fastApiUrl);
    console.log('  Stream Endpoint:', config.streamEndpoint);
  }
};

// Log configuration on load in development
if (config.isDevelopment) {
  config.logConfig();
}

export default config;
